import React from "react";
import { Route, Navigate } from "react-router-dom";

const routes = all_routes;

import SigninTwo from "../feature-module/pages/login/signinTwo";

import { all_routes } from "./all_routes";

import Apexchart from "../feature-module/uiinterface/charts/apexcharts";
import ChartJs from "../feature-module/uiinterface/charts/chartjs";

import FontawesomeIcons from "../feature-module/uiinterface/icons/fontawesome";
import FeatherIcons from "../feature-module/uiinterface/icons/feathericon";
import IonicIcons from "../feature-module/uiinterface/icons/ionicicons";
import MaterialIcons from "../feature-module/uiinterface/icons/materialicon";
import PE7Icons from "../feature-module/uiinterface/icons/pe7icons";
import SimplelineIcons from "../feature-module/uiinterface/icons/simplelineicon";
import ThemifyIcons from "../feature-module/uiinterface/icons/themify";
import WeatherIcons from "../feature-module/uiinterface/icons/weathericons";
import TypiconIcons from "../feature-module/uiinterface/icons/typicons";
import FlagIcons from "../feature-module/uiinterface/icons/flagicons";
import BootstrapIcons from "../feature-module/uiinterface/icons/bootstrapicons";
import RemixIcons from "../feature-module/uiinterface/icons/remixIcons";
import TablerIcon from "../feature-module/uiinterface/icons/tablericon";

import LayoutDemo from "../feature-module/layout-pages/layoutdemo";
import TestForm from "../test";
import SuperAdminDashboard from "../feature-module/super-admin/dashboard";
import Companies from "../feature-module/super-admin/companies";
import Subscription from "../feature-module/super-admin/subscription";
import Packages from "../feature-module/super-admin/packages/packagelist";
import Domain from "../feature-module/super-admin/domin";
import PurchaseTransaction from "../feature-module/super-admin/purchase-transaction";
import HealthCheck from "../feature-module/super-admin/HealthCheck/HealthCheck";
import Devices from "../feature-module/super-admin/Devices/Devices";
import Inactiveclients from "../feature-module/super-admin/InactiveClients/Inactiveclients";
import KeyGenarations from "../feature-module/super-admin/KeyGenrations/KeyGenarations";
import Renewals from "../feature-module/super-admin/Renwals/Renewals";
import RawSwipes from "../feature-module/super-admin/Rawswipes/Rawswipes";
import MobilreUsers from "../feature-module/super-admin/MobileUsers.jsx/MobileUsers";
import Jobs from "../feature-module/super-admin/Jobs/jobs";
import JobsStatus from "../feature-module/super-admin/Jobs/jobstatus";
import Sms from "../feature-module/super-admin/SMS/Sms";
import Queryss from "../feature-module/super-admin/Query/Query";
import QueryExecute from "../feature-module/super-admin/Query/QueryExecute";
import DbHealth from "../feature-module/super-admin/DbHealth/DbHealth";

import RollCallAdminLogin from "../feature-module/super-admin/LoginConfiguration/RollCallAdminLogin";
import RollcallEssLoginPage from "../feature-module/super-admin/LoginConfiguration/RollcallEssLoginPage";
import IbizLoginPage from "../feature-module/super-admin/LoginConfiguration/IbizLoginPage";
import Location from "../feature-module/super-admin/companies/Location";
import DemoApplicationlist from "../feature-module/super-admin/DemoApplicationList/DemoApplicationlist";

export const publicRoutes = [
  {
    id: 46,
    path: routes.apexchart,
    name: "apex-chart",
    element: <Apexchart />,
    route: Route,
  },

  {
    id: 47,
    path: routes.chartjs,
    name: "chart-js",
    element: <ChartJs />,
    route: Route,
  },

  {
    id: 49,
    path: routes.fontawesome,
    name: "fontawesome",
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: "feathericon",
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: "ionicicons",
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: "materialicons",
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: "pe7icons",
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: "simpleline",
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: "themifyicon",
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: "iconweather",
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: "typicons",
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: "flagicons",
    element: <FlagIcons />,
    route: Route,
  },

  {
    id: 106,
    path: routes.remixIcon,
    name: "remixIcon",
    element: <RemixIcons />,
    route: Route,
  },
  {
    id: 107,
    path: routes.BootstrapIcon,
    name: "BootstrapIcon",
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    id: 108,
    path: routes.TablerIcon,
    name: "TablerIcon",
    element: <TablerIcon />,
    route: Route,
  },

  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: "/",
    name: "Root",
    element: <Navigate to="/signin-2" />,
    route: Route,
  },
  {
    id: 143,
    path: routes.superadmindashboard,
    name: "super-admin-dashboard",
    element: <SuperAdminDashboard />,
    route: Route,
  },
  {
    id: 144,
    path: routes.companies,
    name: "companies",
    element: <Companies />,
    route: Route,
  },
  {
    id: 145,
    path: routes.subscription,
    name: "subscription",
    element: <Subscription />,
    route: Route,
  },
  {
    id: 146,
    path: routes.packagelist,
    name: "packages",
    element: <Packages />,
    route: Route,
  },
  {
    id: 147,
    path: routes.domain,
    name: "domain",
    element: <Domain />,
    route: Route,
  },
  {
    id: 148,
    path: routes.purchasetransaction,
    name: "purchase-transaction",
    element: <PurchaseTransaction />,
    route: Route,
  },

  {
    id: 162,
    path: routes.Horizontal,
    name: "layout-horizontal",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 163,
    path: routes.Detached,
    name: "layout-detached",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 164,
    path: routes.Modern,
    name: "layout-modern",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 165,
    path: routes.TwoColumn,
    name: "layout-two-column",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 166,
    path: routes.Hovered,
    name: "layout-hovered",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 167,
    path: routes.Boxed,
    name: "layout-boxed",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 168,
    path: routes.RTL,
    name: "layout-rtl",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 169,
    path: routes.Dark,
    name: "layout-dark",
    element: <LayoutDemo />,
    route: Route,
  },

  {
    id: 174,
    path: routes.healthcheck,
    name: "healthcheck",
    element: <HealthCheck />,
    route: Route,
  },
  {
    id: 175,
    path: routes.devices,
    name: "devices",
    element: <Devices />,
    route: Route,
  },
  {
    id: 176,
    path: routes.inactiveclients,
    name: "inactiveclients",
    element: <Inactiveclients />,
    route: Route,
  },
  {
    id: 177,
    path: routes.keygenrations,
    name: "keygenrations",
    element: <KeyGenarations />,
    route: Route,
  },
  {
    id: 178,
    path: routes.renewals,
    name: "renewals",
    element: <Renewals />,
    route: Route,
  },
  {
    id: 179,
    path: routes.rawswipes,
    name: "rawswipes",
    element: <RawSwipes />,
    route: Route,
  },
  {
    id: 180,
    path: routes.mobileusers,
    name: "mobileusers",
    element: <MobilreUsers />,
    route: Route,
  },
  {
    id: 181,
    path: routes.jobs,
    name: "jobs",
    element: <Jobs />,
    route: Route,
  },
  {
    id: 182,
    path: routes.jobsstatus,
    name: "jobsstatus",
    element: <JobsStatus />,
    route: Route,
  },
  {
    id: 183,
    path: routes.test,
    name: "test",
    element: <TestForm />,
    route: Route,
  },
  {
    id: 184,
    path: routes.sms,
    name: "sms",
    element: <Sms />,
    route: Route,
  },
  {
    id: 185,
    path: routes.query,
    name: "query",
    element: <Queryss />,
    route: Route,
  },
  {
    id: 186,
    path: routes.queryExecute,
    name: "queryExecute",
    element: <QueryExecute />,
    route: Route,
  },
  {
    id: 187,
    path: routes.dbhealth,
    name: "dbhealth",
    element: <DbHealth />,
    route: Route,
  },
 
  {
    id: 188,
    path: routes.rollcalladminlogin,
    name: "rollcalladminlogin",
    element: <RollCallAdminLogin />,
    route: Route,
  },

    {
    id: 189,
    path: routes.rollcallesslogin,
    name: "rollcallesslogin",
    element: <RollcallEssLoginPage />,
    route: Route,
  },
    {
    id: 190,
    path: routes.ibizloginpage,
    name: "ibizloginpage",
    element: <IbizLoginPage />,
    route: Route,
  },
  {
    id: 191,
    path: routes.location,
    name: "location",
    element: <Location />,
    route: Route,
  },
  {
    id: 191,
    path: routes.demoapplicationview,
    name: "demoapplicationview",
    element: <DemoApplicationlist />,
    route: Route,
  },
];
export const posRoutes = [];

export const pagesRoute = [
  {
    id: 2,
    path: routes.signintwo,
    name: "signintwo",
    element: <SigninTwo />,
    route: Route,
  },
];
